var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTruckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.844 19.5577C5.06334 19.5577 4.40059 19.2847 3.85575 18.7387C3.31092 18.1927 3.0385 17.5298 3.0385 16.75H1.34625V6.30775C1.34625 5.80258 1.52125 5.375 1.87125 5.025C2.22125 4.675 2.64875 4.5 3.15375 4.5H16.7693V8.30775H19.423L22.6538 12.6348V16.75H20.8463C20.8463 17.5298 20.573 18.1927 20.0265 18.7387C19.4802 19.2847 18.8168 19.5577 18.0363 19.5577C17.2558 19.5577 16.593 19.2847 16.048 18.7387C15.5032 18.1927 15.2308 17.5298 15.2308 16.75H8.65375C8.65375 17.532 8.38059 18.1954 7.83425 18.7402C7.28792 19.2852 6.6245 19.5577 5.844 19.5577ZM5.84625 18.0577C6.21292 18.0577 6.5225 17.9314 6.775 17.6788C7.0275 17.4263 7.15375 17.1167 7.15375 16.75C7.15375 16.3833 7.0275 16.0737 6.775 15.821C6.5225 15.5685 6.21292 15.4423 5.84625 15.4423C5.47959 15.4423 5.16992 15.5685 4.91725 15.821C4.66475 16.0737 4.5385 16.3833 4.5385 16.75C4.5385 17.1167 4.66475 17.4263 4.91725 17.6788C5.16992 17.9314 5.47959 18.0577 5.84625 18.0577ZM18.0385 18.0577C18.4052 18.0577 18.7148 17.9314 18.9673 17.6788C19.2199 17.4263 19.3463 17.1167 19.3463 16.75C19.3463 16.3833 19.2199 16.0737 18.9673 15.821C18.7148 15.5685 18.4052 15.4423 18.0385 15.4423C17.6718 15.4423 17.3622 15.5685 17.1095 15.821C16.857 16.0737 16.7308 16.3833 16.7308 16.75C16.7308 17.1167 16.857 17.4263 17.1095 17.6788C17.3622 17.9314 17.6718 18.0577 18.0385 18.0577ZM16.7693 13.25H21.25L18.6538 9.80775H16.7693V13.25Z",
    fill: "#FA1861"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckIcon);
export default __webpack_public_path__ + "static/media/TruckIcon.4704b3d92a11825f457d9f717d1716d5.svg";
export { ForwardRef as ReactComponent };